import { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const MODULOS_DEL_EDITOR = {
    toolbar: [
        [{ 'header': [1, 2, 3, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'align': [] }],
        ['link', 'image'],
        ['clean']
    ],
};

// `onChange` recibe la firma de react-quill: (html, delta, origen, editor).
// El editor guarda su propio contenido: si quien lo usa descarta los cambios que hace Quill al
// normalizar el HTML, el `value` recibido ya no coincide con lo que muestra, y react-quill lo
// volvería a pegar (y a subir el scroll) en cada render.
const TextEditor = ({ value, onChange }) => {
    const [mounted, setMounted] = useState(false);
    const [contenido, setContenido] = useState(value);
    useEffect(() => {
        setMounted(true);
    }, []);
    useEffect(() => {
        setContenido(value);
    }, [value]);

    if (!mounted) return <p>Cargando editor...</p>;

    const cambiarContenido = (html, delta, origen, editor) => {
        setContenido(html);
        onChange(html, delta, origen, editor);
    };

    return (
        <ReactQuill
            theme="snow"
            value={contenido}
            onChange={cambiarContenido}
            modules={MODULOS_DEL_EDITOR}
        />
    )
}

export default TextEditor
